import { useNavigate } from "react-router-dom";
import { toast } from "@/lib/toast";
import { useUnseenGrailMatches } from "@/hooks/useFigData";

/**
 * Mounted once near the app root (inside AuthProvider). Pops a toast the
 * moment a new grail match lands for the signed-in user, with a one-tap
 * shortcut to the Grails page. Badge counts are read directly from this
 * hook elsewhere (see BottomDock).
 */
export function GrailMatchListener() {
  const nav = useNavigate();
  useUnseenGrailMatches(() => {
    toast.success("New grail match", {
      description: "Someone just posted a piece from your want list.",
      action: {
        label: "View",
        onClick: () => nav("/grails?focus=matches"),
      },
    });
  });
  return null;
}